// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__OwMxL","content":"Consent_content__16EFj","footer":"Consent_footer__2HbBK"};